export interface FilterOption {
    id: string
    label: string
    value: string
    ariaLabel?: string
}

export interface FilterState {
    type: {
        [optionId: string]: boolean
    }
    party: {
        [optionId: string]: boolean
    }
}

export const DEFAULT_TYPE_OPTIONS: FilterOption[] = [
    { id: "incumbent", label: "Incumbent", value: "incumbent", ariaLabel: "Filter by incumbent candidates" },
    { id: "challenger", label: "Challenger", value: "challenger", ariaLabel: "Filter by challenger candidates" },
]

export const DEFAULT_PARTY_OPTIONS: FilterOption[] = [
    { id: "democrat", label: "Democrat", value: "democrat", ariaLabel: "Filter by Democrat party" },
    { id: "republican", label: "Republican", value: "republican", ariaLabel: "Filter by Republican party" },
    { id: "independent", label: "Independent", value: "independent", ariaLabel: "Filter by Independent party" },
    { id: "other", label: "Other", value: "other", ariaLabel: "Filter by other parties" },
]

export const initializeFilters = (): FilterState => {
    const initialState: FilterState = {
        type: {},
        party: {},
    }

    DEFAULT_TYPE_OPTIONS.forEach((option) => (initialState.type[option.id] = true))
    DEFAULT_PARTY_OPTIONS.forEach((option) => (initialState.party[option.id] = true))

    return initialState
}
